import "./MsActivationLinkExpired.css";
import { useAppTheme } from "../../theme/useTheme";
import { useConfig } from "../../contexts/ConfigContext";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";

function ActivationLinkExpired() {
  const { config } = useConfig();
  const theme = useAppTheme();
  const bambora_url = config?.reportalLoginUrlMS1;
  return (
    <div className="activation-expired-root">
      <div className="activation-expired-content">
        {theme?.assets?.brokenLinkIcon && <img src={theme.assets.brokenLinkIcon} alt="Broken" />}
        <div>
          <h1 className="activation-expired-title">
            <Translate tKey={T_KEYS.MS.LINK_EXPIRED.TITLE} />
          </h1>

          <p className="activation-expired-text">
            <Translate tKey={T_KEYS.MS.LINK_EXPIRED.HEADER} />
            <a href={bambora_url} target="_blank" rel="noopener noreferrer">
              <Translate tKey={T_KEYS.MS.LINK_EXPIRED.REPORT.URL} />
            </a>
            <Translate tKey={T_KEYS.MS.LINK_EXPIRED.REPORT.TEXT} />
          </p>
        </div>

        <div className="activation-expired-footer">
          <img src={theme?.assets?.logo} alt="Worldline" />
        </div>
      </div>
    </div>
  );
}

export default ActivationLinkExpired;
